export default {
  type: 'menu',
  code: '11000000',
  certAuth: {
    type: 'menu',
    code: '11010000',
    orgCert: {
      type: 'menu',
      code: '11010100',
      createOrgCert: {
        type: 'btns',
        code: '11010101'
      },
      importOrgCert: {
        type: 'btns',
        code: '11010102'
      },
      requireOrgCert: {
        type: 'btns',
        code: '11010103'
      }
    },
    nodeCert: {
      type: 'menu',
      code: '11010200',
      createNodeCert: {
        type: 'btns',
        code: '11010201'
      },
      importNodeCert: {
        type: 'btns',
        code: '11010202'
      },
      requireNodeCert: {
        type: 'btns',
        code: '11010203'
      }
    },
    userCert: {
      type: 'menu',
      code: '11010300',
      createUserCert: {
        type: 'btns',
        code: '11010301'
      },
      importUserCert: {
        type: 'btns',
        code: '11010302'
      },
      requireUserCert: {
        type: 'btns',
        code: '11010303'
      }
    }
  },
  IBCAuth: {
    type: 'menu',
    code: '11020000',
    orgCert: {
      type: 'menu',
      code: '11020100',
      createOrgCert: {
        type: 'btns',
        code: '11020101'
      },
      importOrgCert: {
        type: 'btns',
        code: '11020102'
      },
      requireOrgCert: {
        type: 'btns',
        code: '11020103'
      }
    },
    nodeCert: {
      type: 'menu',
      code: '11020200',
      createNodeCert: {
        type: 'btns',
        code: '11020201'
      },
      importNodeCert: {
        type: 'btns',
        code: '11020202'
      },
      requireNodeCert: {
        type: 'btns',
        code: '11020203'
      }
    },
    userCert: {
      type: 'menu',
      code: '11020300',
      createUserCert: {
        type: 'btns',
        code: '11020301'
      },
      importUserCert: {
        type: 'btns',
        code: '11020302'
      },
      requireUserCert: {
        type: 'btns',
        code: '11020303'
      }
    }
  },
  publicKeyAuth: {
    type: 'menu',
    code: '11030000',
    adminCert: {
      type: 'menu',
      code: '11030100',
      createAdminCert: {
        type: 'btns',
        code: '11030101'
      }
    },
    nodeUserCert: {
      type: 'menu',
      code: '11030200',
      createNodeUserCert: {
        type: 'btns',
        code: '11030201'
      }
    }
  }
}
